import { CONTACT } from "@/lib/copy";
import { copyExp } from "@/lib/copyExp";

export function waLink(lang, key = "general") {
  const msg = copyExp[lang]?.wa[key] || copyExp[lang].wa.general;
  return `https://api.whatsapp.com/send?phone=56935609185&text=${encodeURIComponent(msg)}`;
}

export { CONTACT };
